import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			titleDiscount: {
				color: theme.palette.grey[50],
				fontSize: 12,
				width: "100%",
				padding: "10px 0px",
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			},
			title: {
				width: 220,
				textAlign: "center"
			},
			line: {
				borderTop: `1px dashed ${theme.palette.grey[800]}`,
				width: "calc((100% - 220px)/2)"
			}
		}),
	{
		name: "Line",
		index: 1
	}
);

export default useStyles;
